import React, { useEffect, useState } from "react";
import { AnimatePresence, EASE, motion, useReducedMotion } from "../lib/motion";
import { Ornament } from "./Ornament";

const KEY = "sme_intro_seen";

/** Extra delay (s) the hero should add to its own entrance while the intro plays. */
export function introDelay() {
  try { return sessionStorage.getItem(KEY) ? 0 : 1.2; } catch (e) { return 0; }
}

/**
 * One-time brand moment on the first load of a session: श्रीं glows in over the
 * dark ground, the ornament draws itself, the wordmark tracks open — then the
 * whole curtain lifts and hands over to the page. Never shown twice, never
 * shown under reduced motion.
 */
export function Intro() {
  const reduce = useReducedMotion();
  const [show, setShow] = useState(() => {
    try { return !sessionStorage.getItem(KEY); } catch (e) { return false; }
  });

  useEffect(() => {
    if (!show || reduce) return undefined;
    try { sessionStorage.setItem(KEY, "1"); } catch (e) { /* private mode */ }
    document.documentElement.style.overflow = "hidden";
    const t = setTimeout(() => setShow(false), 1350);
    return () => {
      clearTimeout(t);
      document.documentElement.style.overflow = "";
    };
  }, [show, reduce]);

  if (reduce) return null;

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="brand-intro"
          aria-hidden="true"
          className="fixed inset-0 z-[100] flex items-center justify-center"
          style={{ backgroundColor: "#0B0906" }}
          exit={{ y: "-100%", transition: { duration: 0.85, ease: EASE } }}
        >
          <motion.div
            className="px-6 text-center"
            exit={{ opacity: 0, y: -28, transition: { duration: 0.45, ease: "easeIn" } }}
          >
            <motion.p
              className="deva glow-mark text-5xl leading-none text-[#f0d693] sm:text-6xl"
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 1, ease: EASE, delay: 0.1 }}
            >
              श्रीं
            </motion.p>
            <motion.div
              className="mt-7"
              initial={{ opacity: 0, scaleX: 0.3 }}
              animate={{ opacity: 1, scaleX: 1 }}
              transition={{ duration: 0.9, ease: EASE, delay: 0.35 }}
            >
              <Ornament width={70} />
            </motion.div>
            <motion.p
              className="ui mt-7 pl-[0.45em] text-[11px] font-medium uppercase text-[#f3efe7]/75"
              initial={{ opacity: 0, letterSpacing: "0.22em" }}
              animate={{ opacity: 1, letterSpacing: "0.45em" }}
              transition={{ duration: 1.1, ease: EASE, delay: 0.5 }}
            >
              Shreem Mantra Energy
            </motion.p>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
